// GET AGENTES FIRMA
import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

export const getAgentesFirma = async () => {
    const result = await PrivateInterceptor('agents', 'GET');
    return result;
 }

 // OBTENER AGENTES COMPRAS 
export const getAgentesCompras = async() => {
    const respuesta = await PrivateInterceptor(`IT/Users/AgentesCompras`, 'GET')
    return respuesta;
}

// GET AGENTES FIRMA
export const getPublicAgentesFirma = async (token) => {
    const result = await PublicInterceptor('agents', 'GET', {}, token);
    return result;
 }